import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

/* ═══════════════════════════════════════════════════
   FOOTER - pure Tailwind. Sleek editorial on amber bg.
   ═══════════════════════════════════════════════════ */

const svgClass = 'w-[18px] h-[18px] fill-current';
const Icon = {
  Facebook: () => (
    <svg viewBox="0 0 24 24" className={svgClass} aria-hidden>
      <path d="M22 12.07C22 6.51 17.52 2 12 2S2 6.51 2 12.07c0 5 3.66 9.15 8.44 9.93v-7.02H7.9v-2.9h2.54V9.86c0-2.51 1.49-3.9 3.77-3.9 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.57v1.88h2.78l-.44 2.9h-2.34V22c4.78-.78 8.44-4.93 8.44-9.93z" />
    </svg>
  ),
  Instagram: () => (
    <svg viewBox="0 0 24 24" className={svgClass} aria-hidden>
      <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 01-1.38-.9 3.7 3.7 0 01-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.87 5.87 0 00-2.13 1.38A5.87 5.87 0 00.63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91a5.87 5.87 0 001.38 2.13 5.87 5.87 0 002.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.87 5.87 0 002.13-1.38 5.87 5.87 0 001.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.87 5.87 0 00-1.38-2.13A5.87 5.87 0 0019.86.63C19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1018.16 12 6.16 6.16 0 0012 5.84zm0 10.16A4 4 0 1116 12a4 4 0 01-4 4zm6.4-11.85a1.44 1.44 0 101.44 1.44 1.44 1.44 0 00-1.44-1.44z" />
    </svg>
  ),
  X: () => (
    <svg viewBox="0 0 24 24" className={svgClass} aria-hidden>
      <path d="M18.244 2H21l-6.54 7.47L22 22h-6.875l-4.64-5.47L4.6 22H1.845l6.99-7.99L1 2h7.06l4.2 5.01L18.244 2zm-2.4 18.25h1.52L7.66 3.64H6.04l9.804 16.61z" />
    </svg>
  ),
  YouTube: () => (
    <svg viewBox="0 0 24 24" className={svgClass} aria-hidden>
      <path d="M23.5 6.2a3 3 0 00-2.1-2.12C19.5 3.56 12 3.56 12 3.56s-7.5 0-9.4.52A3 3 0 00.5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 002.1 2.12c1.9.52 9.4.52 9.4.52s7.5 0 9.4-.52a3 3 0 002.1-2.12C24 15.9 24 12 24 12s0-3.9-.5-5.8zM9.56 15.57V8.43L15.82 12l-6.26 3.57z" />
    </svg>
  ),
  LinkedIn: () => (
    <svg viewBox="0 0 24 24" className={svgClass} aria-hidden>
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.95v5.66H9.35V9h3.41v1.56h.05a3.74 3.74 0 013.37-1.85c3.6 0 4.27 2.37 4.27 5.46zM5.34 7.43a2.07 2.07 0 11.0-4.14 2.07 2.07 0 010 4.14zM7.12 20.45H3.56V9h3.56zM22.22 0H1.77C.8 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z" />
    </svg>
  ),
  Pinterest: () => (
    <svg viewBox="0 0 24 24" className={svgClass} aria-hidden>
      <path d="M12 0a12 12 0 00-4.37 23.17c-.1-.94-.2-2.4.04-3.43.22-.93 1.4-5.94 1.4-5.94s-.36-.72-.36-1.78c0-1.67.97-2.91 2.17-2.91 1.03 0 1.52.77 1.52 1.7 0 1.03-.66 2.57-1 4a1.74 1.74 0 001.78 2.18c2.14 0 3.78-2.26 3.78-5.51 0-2.88-2.07-4.9-5.03-4.9-3.43 0-5.44 2.57-5.44 5.23 0 1.03.4 2.14.9 2.75a.36.36 0 01.08.35l-.33 1.35c-.05.21-.17.26-.4.16-1.5-.7-2.44-2.89-2.44-4.65 0-3.78 2.75-7.26 7.93-7.26 4.16 0 7.4 2.97 7.4 6.93 0 4.13-2.6 7.46-6.22 7.46-1.22 0-2.36-.63-2.75-1.38l-.75 2.85c-.27 1.04-1 2.35-1.49 3.15A12 12 0 1012 0z" />
    </svg>
  ),
};

const SOCIALS = [
  { key: 'fb',  label: 'Facebook',  href: 'https://www.facebook.com/EsayConstructionalServices',                  Icon: Icon.Facebook  },
  { key: 'ig',  label: 'Instagram', href: 'https://www.instagram.com/esayindia',                                  Icon: Icon.Instagram },
  { key: 'x',   label: 'X',         href: 'https://twitter.com/EsayIndia',                                        Icon: Icon.X         },
  { key: 'yt',  label: 'YouTube',   href: 'https://www.youtube.com/channel/UCzYGKghiLJ9Vku678tvIASQ',             Icon: Icon.YouTube   },
  { key: 'li',  label: 'LinkedIn',  href: 'https://www.linkedin.com/company/esay-engineering-sources-around-you', Icon: Icon.LinkedIn  },
  { key: 'pi',  label: 'Pinterest', href: 'https://in.pinterest.com/esayindia',                                   Icon: Icon.Pinterest },
];

const label    = 'block mb-2 text-[10px] font-bold uppercase tracking-[0.16em] text-ink/55';
const link     = 'block py-[3px] text-[13px] text-ink/80 leading-snug transition-colors duration-200 ease-out-soft hover:text-ink';
const email    = 'block py-[2px] text-[13px] font-semibold text-ink leading-snug transition-opacity duration-200 ease-out-soft hover:opacity-70';
const social   = 'text-ink/65 transition-[color,transform] duration-200 ease-out-soft hover:text-ink hover:-translate-y-0.5';
const credImg  = 'block object-contain';
const credLift = 'inline-flex transition-transform duration-200 ease-out-soft hover:-translate-y-0.5';
const drop     = 'drop-shadow-[0_3px_6px_rgba(10,10,11,0.25)]';

export const Footer = () => (
  <footer className="relative isolate overflow-hidden bg-amber-gradient text-ink/80">
    {/* noise overlay */}
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 -z-10 opacity-[0.08] mix-blend-multiply"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
      }}
    />

    {/* ─────── Main content ─────── */}
    <div className="mx-auto w-full max-w-[1120px] px-5 pt-7 pb-5 sm:px-8 lg:px-6">

      {/* Top grid: brand left, link columns right */}
      <div className="grid grid-cols-12 gap-x-6 gap-y-6">

        {/* Brand + tagline + socials */}
        <div className="col-span-12 md:col-span-5 lg:col-span-4">
          <div className="flex items-center gap-3.5">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-ink shadow-ink-soft">
              <img src="/assets/ESAY.png" alt="" className="h-8 w-8 object-contain" />
            </span>
            <span className="text-[28px] font-black leading-none tracking-[-0.035em] text-ink">ESAY</span>
          </div>
          <p className="mt-3 max-w-[360px] text-[13px] leading-[1.55] text-ink/70">
            Engineering Sources Around You - the construction industry&rsquo;s directory of contacts, information and trends.
          </p>
          <div className="mt-4 flex items-center gap-4">
            {SOCIALS.map(({ key, label: lbl, href, Icon }) => (
              <a
                key={key}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={lbl}
                title={lbl}
                className={social}
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        {/* Explore */}
        <div className="col-span-6 sm:col-span-4 md:col-span-2 lg:col-span-2">
          <span className={label}>Explore</span>
          <nav>
            <RouterLink to="/about"                       className={link}>About</RouterLink>
            <RouterLink to="/awards_news"                 className={link}>Awards &amp; News</RouterLink>
            <RouterLink to="/esay_tutorials_walkthroughs" className={link}>Tutorials</RouterLink>
            <RouterLink to="/faqs"                        className={link}>FAQs</RouterLink>
          </nav>
        </div>

        {/* Legal */}
        <div className="col-span-6 sm:col-span-4 md:col-span-2 lg:col-span-2">
          <span className={label}>Legal</span>
          <nav>
            <RouterLink to="/terms"           className={link}>Terms</RouterLink>
            <RouterLink to="/privacy_policy"  className={link}>Privacy</RouterLink>
            <RouterLink to="/acknowledgments" className={link}>Acknowledgments</RouterLink>
            <RouterLink to="/contact-now"     className={link}>Contact</RouterLink>
          </nav>
        </div>

        {/* Reach us - emails */}
        <div className="col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-4">
          <span className={label}>Reach us</span>
          <a href="mailto:contact@esay.in"    className={email}>contact@esay.in</a>
          <a href="mailto:contact@arawinz.com" className={email}>contact@arawinz.com</a>
        </div>
      </div>

      {/* ─── Apps + Awards strip ─── */}
      <div className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-3 border-t border-black/15 pt-5">
        <a
          href="https://play.google.com/store/apps/details?id=com.esay.arawinzsoft"
          target="_blank"
          rel="noreferrer"
          aria-label="Get it on Google Play"
          className={credLift}
        >
          <img src="/assets/gplay.png" alt="Get it on Google Play" className={`${credImg} h-11`} />
        </a>
        <a
          href="https://apps.apple.com/us/app/esay/id1490576735?ls=1"
          target="_blank"
          rel="noreferrer"
          aria-label="Download on the App Store"
          className={credLift}
        >
          <img src="/assets/iosstore.png" alt="Download on the App Store" className={`${credImg} h-11`} />
        </a>

        <span aria-hidden className="hidden sm:inline-block h-9 w-px bg-ink/25" />

        <RouterLink
          to="/article-details/arawinz-receives-15th-vishwakarma-award-from-cidc-in-innovator-category-in-new-delhi/4"
          aria-label="CIDC Vishwakarma Award"
          title="15th Vishwakarma Award"
          className={`${credLift} hover:brightness-110`}
        >
          <img src="/awards/cidc_award.png" alt="CIDC Vishwakarma Award" className={`${credImg} ${drop} h-24`} />
        </RouterLink>
        <RouterLink
          to="/article-details/arawinz-soft-solutions-wins-best-construction-startup-at-2024-best-engineers-awards-for-esay/9"
          aria-label="Best Construction Startup 2024"
          title="Best Construction Startup 2024"
          className={`${credLift} hover:brightness-110`}
        >
          <img src="/awards/hindu_award.png" alt="Best Construction Startup 2024" className={`${credImg} ${drop} h-24`} />
        </RouterLink>
        <RouterLink
          to="/article-details/esay-wins-innovation-of-the-year-at-golden-brick-awards-2025-dubai/10"
          aria-label="Innovation of the Year - Golden Brick Awards 2025 Dubai"
          title="Innovation of the Year - Golden Brick Awards 2025"
          className={`${credLift} hover:brightness-110`}
        >
          <img src="/awards/golden_brick_award.png" alt="Innovation of the Year - Golden Brick Awards 2025" className={`${credImg} ${drop} h-24`} />
        </RouterLink>
      </div>
    </div>

    {/* ─── Bottom bar (dark, thin) ─── */}
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-t border-black/30 bg-surface-base px-5 py-2.5 text-center">
      <span className="text-[11px] tracking-wide text-fg-tertiary">&copy; {new Date().getFullYear()} ESAY</span>
      <span aria-hidden className="inline-block h-[3px] w-[3px] rounded-full bg-border-strong" />
      <span className="text-[11px] tracking-wide text-fg-tertiary">
        A product of{' '}
        <a
          href="https://arawinz.com"
          target="_blank"
          rel="noreferrer"
          className="font-bold text-amber hover:text-amber-light"
        >
          Arawinz Soft Solutions
        </a>
      </span>
    </div>
  </footer>
);
